import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-tisco-step-buy',
    templateUrl: './tisco-step-buy.component.html',
    styleUrls: ['./tisco-step-buy.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TiscoStepBuyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
